import { memo } from "react";
import PropTypes from "prop-types";
import OTPInput from "./OTPInput";
import OTPAction from "./OTPAction";
import OTPTitle from "./OTPTitle";

const OTPVerify = ({ className, TitleProps, InputProps, ActionProps }) => {
  return (
    <div className={`w-100 ${className || ""}`}>
      <OTPTitle {...TitleProps} />
      <OTPInput {...InputProps} />
      <OTPAction {...ActionProps} />
    </div>
  );
};

OTPVerify.propTypes = {
  className: PropTypes.string,
  TitleProps: PropTypes.shape(OTPTitle.propTypes),
  InputProps: PropTypes.shape(OTPInput.propTypes),
  ActionProps: PropTypes.shape(OTPAction.propTypes),
};

export default memo(OTPVerify);
